import React, { createContext, useState, useContext } from 'react';

const FooterContext = createContext();

export const useFooter = () => useContext(FooterContext);

export const FooterProvider = ({ children }) => {
  const [modalContent, setModalContent] = useState({ title: '', text: '' });
  const [isFooterModalOpen, setFooterModalOpen] = useState(false);

  const openFooterModal = (content) => {
    setModalContent(content);
    setFooterModalOpen(true);
  };

  const closeFooterModal = () => {
    setFooterModalOpen(false);
  };

  return (
    <FooterContext.Provider value={{ openFooterModal, closeFooterModal, modalContent, isFooterModalOpen }}>
      {children}
    </FooterContext.Provider>
  );
};
